import { render, staticRenderFns } from "./TextSchedules.vue?vue&type=template&id=5fda57c0&scoped=true"
import script from "./TextSchedules.vue?vue&type=script&lang=js"
export * from "./TextSchedules.vue?vue&type=script&lang=js"
import style0 from "./TextSchedules.vue?vue&type=style&index=0&id=5fda57c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda57c0",
  null
  
)

export default component.exports